// REST API utilities for Supplier Capabilities
import { RestURL } from '../config/properties';

/**
 * Get authentication token from auth object or localStorage
 */
const getAuthToken = (auth = null) => {
    // Try to get token from auth object first (preferred method)
    if (auth && auth.jwtToken) {
        return auth.jwtToken;
    }

    // Fallback to localStorage
    const token = localStorage.getItem('token') || localStorage.getItem('jwtToken');
    if (token) {
        return token;
    }

    // If no token found anywhere
    console.warn('No authentication token found in auth object or localStorage');
    return null;
};

/**
 * Make authenticated REST API request
 */
const makeRestRequest = async (endpoint, options = {}, auth = null) => {
    const token = getAuthToken(auth);

    const defaultOptions = {
        headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` }),
            ...options.headers,
        },
    };

    const response = await fetch(`${RestURL}${endpoint}`, {
        ...defaultOptions,
        ...options,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
        );
    }

    return response.json();
};

/**
 * Get supplier capabilities by CAGE code
 * GET /rest/supplier/capabilities/{cage}
 */
export const getSupplierCapabilities = async (cage, auth = null) => {
    try {
        console.log(`Fetching supplier capabilities for CAGE: ${cage}`);
        const data = await makeRestRequest(`rest/supplier/capabilities/${cage}`, {
            method: 'GET',
        }, auth);
        console.log('Supplier capabilities response:', data);
        return data;
    } catch (error) {
        console.error('Error fetching supplier capabilities:', error);
        throw error;
    }
};

/**
 * Update supplier capabilities
 * POST /rest/supplier/capabilities
 */
export const updateSupplierCapabilities = async (supplierCaps, auth = null) => {
    try {
        console.log('Updating supplier capabilities:', supplierCaps);
        console.log('minMaxDimensions:', supplierCaps.minMaxDimensions);

        const data = await makeRestRequest('rest/supplier/capabilities', {
            method: 'POST',
            body: JSON.stringify(supplierCaps),
        }, auth);

        console.log('Update response:', data);
        return data;
    } catch (error) {
        console.error('Error updating supplier capabilities:', error);
        throw error;
    }
};

/**
 * Search suppliers
 * POST /rest/supplier/search
 */
export const searchSuppliers = async (searchCriteria, auth = null) => {
    try {
        console.log('Searching suppliers with criteria:', searchCriteria);

        const data = await makeRestRequest('rest/supplier/search', {
            method: 'POST',
            body: JSON.stringify(searchCriteria),
        }, auth);

        console.log('Search response:', data);
        return data;
    } catch (error) {
        console.error('Error searching suppliers:', error);
        throw error;
    }
};

/**
 * Get supplier menu options
 * GET /rest/supplier/menu
 */
export const getSupplierMenu = async (auth = null) => {
    try {
        console.log('Fetching supplier menu options');

        const data = await makeRestRequest('rest/supplier/menu', {
            method: 'GET',
        }, auth);

        console.log('Supplier menu response:', data);
        return data;
    } catch (error) {
        console.error('Error fetching supplier menu:', error);
        throw error;
    }
};

/**
 * Insert test dimensions
 * GET /rest/supplier/test-dimensions
 */
export const insertTestDimensions = async (auth = null) => {
    try {
        console.log('Inserting test dimensions');

        const data = await makeRestRequest('rest/supplier/test-dimensions', {
            method: 'GET',
        }, auth);

        console.log('Test dimensions response:', data);
        return data;
    } catch (error) {
        console.error('Error inserting test dimensions:', error);
        throw error;
    }
};

/**
 * Get supplier options
 * GET /rest/supplier/options
 */
export const getSupplierOptions = async (auth = null) => {
    try {
        console.log('Fetching supplier options');

        const data = await makeRestRequest('rest/supplier/options', {
            method: 'GET',
        }, auth);

        console.log('Supplier options response:', data);
        return data;
    } catch (error) {
        console.error('Error fetching supplier options:', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/utils/supplierRestApi.js